import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiAccordion, { AccordionProps } from '@material-ui/core/Accordion';

const Accordion: React.FC<AccordionProps> = withStyles((theme) => ({
  root: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&::before': {
      content: 'none',
    },
  },
}))(MuiAccordion);

export default Accordion;
